import React, { useEffect, useRef, useState } from "react";
import { apiRequest } from "../apiService/allapi";

function BankDetalis() {
  const [bank, setBank] = useState([]);

  const Bankinfo = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest("/AppInfo/BankerInformation", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res.data?.data?.status === true) {
        setBank(res.data.data.data);
      }
    } catch (error) {
      console.log("Bank API Error:", error);
    }
  };

  useEffect(() => {
    Bankinfo();
  }, []);
  return (
    <>
      <section className="bank-section">
        <div className="container">
          <div className="bank-heading">
            <h5>Bank Details</h5>
            <p>Official Bank Account Information</p>
          </div>

          <div className="row justify-content-center">
            {bank && (
              <div className="col-lg-5 col-md-7">
                <div className="bank-card">
                  <div className="bank-logo">
                    <img src={bank.logo} alt={bank.bankName} />
                  </div>

                  <div className="table-responsive">
                    <table className="table bank-table">
                      <tbody>
                        <tr>
                          <td>Bank Name</td>
                          <td>{bank.bankName}</td>
                        </tr>

                        <tr>
                          <td>Account Name</td>
                          <td>{bank.accountName}</td>
                        </tr>

                        <tr>
                          <td>Account No.</td>
                          <td>{bank.accountNo}</td>
                        </tr>

                        <tr>
                          <td>IFSC Code</td>
                          <td>{bank.ifscCode}</td>
                        </tr>

                        <tr>
                          <td>Branch</td>
                          <td>{bank.branch}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default BankDetalis;
